import { render, staticRenderFns } from "./SimpleTableCalculoAdministrativo.vue?vue&type=template&id=400a9203&scoped=true"
import script from "./SimpleTableCalculoAdministrativo.vue?vue&type=script&lang=js"
export * from "./SimpleTableCalculoAdministrativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400a9203",
  null
  
)

export default component.exports